var _rect, _circle, _path, _path2, _path3, _circle2, _circle3, _circle4, _circle5, _path4, _circle6, _circle7, _ellipse, _ellipse2, _ellipse3, _path5, _ellipse4, _circle8, _ellipse5, _circle9, _path6, _path7, _path8, _path9, _path10, _circle10, _circle11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayerPortrait9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#7a5aa8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 52,
    fill: "#896db2",
    opacity: 0.55
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 124C12 98 34 90 60 90S108 98 108 124Z",
    fill: "#262a33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44 90L56 124L30 124C26 108 32 96 44 90ZM76 90L64 124L90 124C94 108 88 96 76 90Z",
    fill: "#1e2128"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44 90L52 100L56 92M76 90L68 100L64 92",
    fill: "#f4f1ea",
    fillOpacity: 0,
    stroke: "#51545b",
    strokeWidth: 1.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 104,
    r: 1.6,
    fill: "#d8dde3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 112,
    r: 1.6,
    fill: "#d8dde3"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 104,
    r: 1.6,
    fill: "#d8dde3"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 112,
    r: 1.6,
    fill: "#d8dde3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52 70H68V92C66 96 54 96 52 92Z",
    fill: "#563224"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 56,
    r: 5,
    fill: "#62392a"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 56,
    r: 5,
    fill: "#62392a"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60,
    cy: 52,
    rx: 21,
    ry: 25,
    fill: "#62392a"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45,
    cy: 63,
    rx: 4,
    ry: 2.4,
    fill: "#e8806a",
    opacity: 0.3
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 75,
    cy: 63,
    rx: 4,
    ry: 2.4,
    fill: "#e8806a",
    opacity: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 57Q56.5 62 59 63.5Q60 64 61.5 63.5",
    stroke: "#4c2c20",
    strokeWidth: 1.8,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 51,
    cy: 54,
    rx: 2.5,
    ry: 3,
    fill: "#2a1d1a"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.9,
    cy: 53,
    r: 0.9,
    fill: "#fff"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 69,
    cy: 54,
    rx: 2.5,
    ry: 3,
    fill: "#2a1d1a"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.9,
    cy: 53,
    r: 0.9,
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46 48Q51 44 56 47",
    stroke: "#2a1d1a",
    strokeWidth: 2.2,
    fill: "none",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64 48Q69 44 74 47",
    stroke: "#2a1d1a",
    strokeWidth: 2.2,
    fill: "none",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53 69Q60 72 68 66",
    stroke: "#2a1d1a",
    strokeWidth: 2.2,
    fill: "none",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54 16C56 12 64 12 66 16L68 40C64 44 56 44 52 40Z",
    fill: "#e8564a"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40 44C42 38 46 36 52 36L52 42C46 42 42 44 40 48Z M80 44C78 38 74 36 68 36L68 42C74 42 78 44 80 48Z",
    fill: "#e8564a",
    opacity: 0.35
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 65,
    r: 2.2,
    fill: "#f0c24a"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 65,
    r: 2.2,
    fill: "#f0c24a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerPortrait9);
export default __webpack_public_path__ + "static/media/player-portrait-9.7bdad2f518cf96294f7af693fde80158.svg";
export { ForwardRef as ReactComponent };